var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cf-c-video-player",style:(_vm.boxStyle)},[_c('iframe',{ref:"video",staticClass:"cf-c-video-player__frame",style:({ maxWidth: `${(_vm.height * 16) / 9}px` }),attrs:{"src":_vm.embedSrc,"frameborder":"0","allowfullscreen":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }